const regex24h = /^([01]\d|2[0-3]):[0-5]\d$/;
// Matches: "09:30 AM", "9:30 PM", "09:30am", "09:30PM" (with or without space, case insensitive)
const regex12h = /^(0?[1-9]|1[0-2]):[0-5]\d\s?(AM|PM)$/i;

export const isValidTime = (time: string, format12h = false) => {
  if (!format12h) {
    return regex24h.test(time);
  }
  // Normalize: add space before AM/PM if missing for consistent validation
  const normalized = time.trim().replace(/(\d)(am|pm)$/i, "$1 $2");
  return regex12h.test(normalized);
};
